import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Ui::Circle\n  @color={{@color}}\n  class=\'chart-legend-indicator\'\n  width=\'12\'\n  height=\'12\'\n  ...attributes\n/>")